import { FC } from 'react';
import { TaskContentBox } from './shared/taskContentBox';

export const ImportsPage: FC = () => {
  return <TaskContentBox type="import" />;
};
